<template lang="html">
  <div :style="themableStyle" class="theme-color">
    <article class="media">
      <figure class="media-left">
        <figure class="image is-48x48">
          <img
            style="border-radius: 50%"
            :src="currentUser.attributes.avatar.url"
            alt="avatar"
          />
        </figure>
      </figure>
      <div class="media-content">
        <div class="field">
          <p class="control">
            <b-input
              maxlength="1000"
              ref="comment"
              rows="1"
              placeholder="Your comment ..."
              v-model="content"
              type="textarea"
              @keyup.native.escape.exact="cancelReply"
              @keydown.native.enter.exact.prevent
              @keyup.native.enter.exact="addComment"
            ></b-input>
          </p>
        </div>
        <div class="field">
          <p class="buttons">
            <b-button v-if="replying" @click="cancelReply"> Cancel </b-button>
            <b-button icon-left="send" @click="addComment" type="is-primary">
              Send
            </b-button>
          </p>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { themableMixin } from '@/mixins/themableMixin'
export default {
  mixins: [themableMixin],
  props: ['replying', 'replyContent', 'theme'],
  data () {
    return {
      content: null
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    }),
    themableTheme () {
      return this.theme ? this.theme.name : null
    }
  },
  methods: {
    resizeComment () {
      var el = this.$refs.comment.$el.childNodes[0]
      setTimeout(function () {
        el.style.height = 'auto'
        el.style.height = el.scrollHeight + 'px'
        el.style.overflow += 'hidden'
      }, 0)
    },
    addComment () {
      if (this.content != null) {
        this.$emit('addComment', this.content)
        this.content = null
      }
    },
    cancelReply () {
      this.$emit('cancelReply')
    }
  },
  created () {
    if (this.replying) {
      if (this.replyContent) this.content = this.replyContent
      this.$nextTick(() => {
        this.$refs.comment.$el.childNodes[0].focus()
        this.resizeComment()
        this.$refs.comment.$el.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        })
      })
    }
  },
  watch: {
    content () {
      this.resizeComment()
    }
  }
}
</script>

<style lang="scss" scoped>
textarea {
  /* box-sizing: padding-box; */
  overflow: hidden;
}
.textarea {
  resize: none !important;
}
.submit-button {
  vertical-align: middle;
}
</style>
